import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';
//红包列表
export const findRedPacketList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket?` + params,
        method: 'GET'
    })
}
export const findRedPacketListDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/downloadExcel?` + params,
        method: 'GET'
    })
}

export const findLabelList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label/select?` + params,
        method: 'GET'
    })
}
export const getBalance = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/balance/getBalance?` + params,
        method: 'GET'
    })
}

export const addRedPacket = (params) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/agent`,
        method: 'POST',
        data: params
    })
}
export const balancePay = (params) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/balancePay`,
        method: 'POST',
        data: params
    })
}
export const immediatePay = (params) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/immediatePay`,
        method: 'POST',
        data: params
    })
}


export const editTags = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer`,
        method: 'PUT',
        data: params
    })
}
